import React, { createContext, useState, useContext } from 'react';

const HeaderSlotContext = createContext({
    headerContent: null,
    setHeaderContent: () => {},
});

export const HeaderSlotProvider = ({ children }) => {
    const [headerContent, setHeaderContent] = useState(null);

    return (
        <HeaderSlotContext.Provider value={{ headerContent, setHeaderContent }}>
            {children}
        </HeaderSlotContext.Provider>
    );
};

export const useHeaderSlot = () => useContext(HeaderSlotContext);
